import { render, staticRenderFns } from "./VendorHeader.vue?vue&type=template&id=73abe993"
import script from "./VendorHeader.vue?vue&type=script&lang=js"
export * from "./VendorHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports